import { useEffect, useRef } from "react";

export default function usePaginationScroll(page, offset = 12) {
  const sectionRef = useRef(null);
  const hasMountedRef = useRef(false);

  useEffect(() => {
    if (!hasMountedRef.current) {
      hasMountedRef.current = true;
      return;
    }

    const target = sectionRef.current;

    if (!target || typeof window === "undefined") {
      return;
    }

    const nextTop = target.getBoundingClientRect().top + window.scrollY - offset;

    window.scrollTo({
      top: Math.max(0, nextTop),
      left: 0,
      behavior: "smooth"
    });
  }, [offset, page]);

  return sectionRef;
}